import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserReferral = React.lazy(() =>
    import('../UserReferral')
);
const userReferralRoutesRegistry = [
    {
        path: PAGE_URL.USER_REFERRAL_PAGE,
        element: <UserReferral />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userReferralRoutesRegistry;
